import api from "../api";
import { createError, logError, logSuccess } from "./message";
import types from "./types";

function requestPlanList() {
  return {
    type: types.GET_PLAN_LIST_REQUEST,
    isFetchingPlanList: true
  };
}

function requestPlanListCompleted(planList) {
  return {
    type: types.GET_PLAN_LIST_COMPLETED,
    isFetchingPlanList: false,
    planList
  };
}

function requestPlanListError(plansError) {
  return {
    type: types.GET_PLAN_LIST_ERROR,
    isFetchingPlanList: false,
    plansError
  };
}

function requestGroupList() {
  return {
    type: types.GET_PLAN_GROUP_LIST_REQUEST,
    isFetchingPlanGroupList: true
  };
}

function requestGroupListCompleted(planGroupList) {
  return {
    type: types.GET_PLAN_GROUP_LIST_COMPLETED,
    isFetchingPlanGroupList: false,
    planGroupList
  };
}

function requestGroupListError(planGroupsError) {
  return {
    type: types.GET_PLAN_GROUP_LIST_ERROR,
    isFetchingPlanGroupList: false,
    planGroupsError
  };
}

function requestOrgList() {
  return {
    type: types.GET_ORG_LIST_REQUEST,
    isFetchingOrganizations: true
  };
}

function requestOrgListCompleted(organizations) {
  return {
    type: types.GET_ORG_LIST_COMPLETED,
    isFetchingOrganizations: false,
    organizations
  };
}

function requestOrgListError(orgError) {
  return {
    type: types.GET_ORG_LIST_ERROR,
    isFetchingOrganizations: false,
    orgError
  };
}

function requestProgramList() {
  return {
    type: types.GET_PROGRAM_LIST_REQUEST,
    isFetchingPrograms: true
  };
}

function requestProgramListCompleted(programs) {
  return {
    type: types.GET_PROGRAM_LIST_COMPLETED,
    isFetchingPrograms: false,
    programs
  };
}

function requestProgramListError(programsError) {
  return {
    type: types.GET_PROGRAM_LIST_ERROR,
    isFetchingPrograms: false,
    programsError
  };
}

function requestPlanCard() {
  return {
    type: types.GET_PLAN_CARD_REQUEST,
    isFetchingPlanCard: true
  };
}

function requestPlanCardCompleted(planCard) {
  return {
    type: types.GET_PLAN_CARD_COMPLETED,
    isFetchingPlanCard: false,
    planCard
  };
}

function requestPlanCardError(planCardError) {
  return {
    type: types.GET_PLAN_CARD_ERROR,
    isFetchingPlanCard: false,
    planCardError
  };
}

function requestPlanSystem() {
  return {
    type: types.GET_PLAN_SYSTEM_REQUEST,
    isFetchingPlan: true,
    planMain: null
  };
}

function requestPlanSystemCompleted(planSystem) {
  console.log(planSystem);
  return {
    type: types.GET_PLAN_SYSTEM_COMPLETED,
    isFetchingPlan: false,
    planSystem
  };
}

function requestPlanSystemError(planSystemError) {
  return {
    type: types.GET_PLAN_SYSTEM_ERROR,
    isFetchingPlan: false,
    planSystemError
  };
}

function requestPlanMain() {
  return {
    type: types.GET_PLAN_MAIN_REQUEST,
    isFetchingPlanMain: true
  };
}

function requestPlanMainCompleted(planMain) {
  return {
    type: types.GET_PLAN_MAIN_COMPLETED,
    isFetchingPlanMain: false,
    planMain
  };
}

function requestPlanMainError(planMainError) {
  return {
    type: types.GET_PLAN_MAIN_ERROR,
    isFetchingPlanMain: false,
    planMainError
  };
}

export function getPlanList() {
  return dispatch => {
    dispatch(requestPlanList());
    return api
      .getPlanList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPlanListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestPlanListError(message));
        } else {
          logError(err);
          dispatch(
            requestPlanListError(createError("Не удалось загрузить список"))
          );
        }
      });
  };
}

export function getPlanGroups(id) {
  return dispatch => {
    dispatch(requestGroupList());
    return api
      .getPlanGroups(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestGroupListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestGroupListError(message));
        } else {
          logError(err);
          dispatch(
            requestGroupListError(
              createError("Не удалось загрузить список групп учебного плана")
            )
          );
        }
      });
  };
}

export function getPlanCard(id) {
  return dispatch => {
    dispatch(requestPlanCard());
    return api
      .getPlanCard(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPlanCardCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestPlanCardError(message));
        } else {
          logError(err);
          dispatch(
            requestPlanCardError(createError("Не удалось загрузить карточку"))
          );
        }
      });
  };
}

export function getPlanSystemInfo(id) {
  return dispatch => {
    dispatch(requestPlanSystem());
    return api
      .getPlanSystem(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestPlanSystemCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestPlanSystemError(message));
        } else {
          logError(err);
          dispatch(
            requestPlanSystemError(createError("Не удалось загрузить данные"))
          );
        }
      });
  };
}

export function getPlanMainInfo(id) {
  return dispatch => {
    dispatch(requestPlanMain());
    return api
      .getPlanMain(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestPlanMainCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestPlanMainError(message));
        } else {
          logError(err);
          dispatch(
            requestPlanMainError(createError("Не удалось загрузить данные"))
          );
        }
      });
  };
}

//GET ORGANIZATION LIST
export function getOrganizations() {
  return dispatch => {
    dispatch(requestOrgList());
    return api
      .getEducationOrgList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestOrgListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestOrgListError(message));
        } else {
          logError(err);
          dispatch(
            requestOrgListError(
              createError("Не удалось загрузить список организаций")
            )
          );
        }
      });
  };
}

//GET PROGRAM LIST
export function getPrograms(orgId) {
  return dispatch => {
    dispatch(requestProgramList());
    return api
      .getProgramList(orgId)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestProgramListCompleted(resp.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestProgramListError(message));
        } else {
          logError(err);
          dispatch(
            requestProgramListError(
              createError("Не удалось загрузить список программ обучения")
            )
          );
        }
      });
  };
}

export function getActualPrograms(orgId) {
  return dispatch => {
    dispatch(requestProgramList());
    return api
      .getActualProgramList(orgId)
      .then(response => {
        if (response.status === 200) {
          //let resp = response.data;
          dispatch(requestProgramListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestProgramListError(message));
        } else {
          logError(err);
          dispatch(
            requestProgramListError(
              createError("Не удалось загрузить список программ обучения")
            )
          );
        }
      });
  };
}

function requestPlanWaitingList() {
  return {
    type: types.GET_PLAN_WAITING_LIST_REQUEST,
    isFetchingPlanWaitingList: true
  };
}

function requestPlanWaitingListCompleted(planWaitingList) {
  return {
    type: types.GET_PLAN_WAITING_LIST_COMPLETED,
    isFetchingPlanWaitingList: false,
    planWaitingList
  };
}

function requestPlanWaitingListError(planWaitingListError) {
  return {
    type: types.GET_PLAN_WAITING_LIST_ERROR,
    isFetchingPlanWaitingList: false,
    planWaitingListError
  };
}

//GET PLAN WAITING LIST
export function getPlanWaitingList() {
  return (dispatch, getState) => {
    const id = getState().studyPlan.planSystem.id;
    dispatch(requestPlanWaitingList());
    return api
      .getPlanWaitingList(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPlanWaitingListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestPlanWaitingListError(message));
        } else {
          logError(err);
          dispatch(
            requestPlanWaitingListError(
              createError("Не удалось загрузить лист ожидания")
            )
          );
        }
      });
  };
}

function requestRemoveGroup() {
  return {
    type: types.REMOVE_GROUP_REQUEST,
    isRemovingGroup: true
  };
}

function requestRemoveGroupCompleted(removedGroup) {
  return {
    type: types.REMOVE_GROUP_COMPLETED,
    isRemovingGroup: false,
    removedGroup
  };
}

function requestRemoveGroupError(groupRemovingError) {
  return {
    type: types.REMOVE_GROUP_ERROR,
    isRemovingGroup: false,
    groupRemovingError
  };
}

//Remove Plan group
export function removePlanGroup(groupId) {
  return (dispatch, getState) => {
    const id = getState().studyPlan.planCard.id;
    dispatch(requestRemoveGroup());
    return api
      .deletePlanGroup(id, groupId)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestRemoveGroupCompleted(resp.data));
          dispatch(getPlanGroups(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestRemoveGroupError(message));
        } else {
          logError(err);
          dispatch(
            requestRemoveGroupError(createError("Не удалось удалить группу"))
          );
        }
      });
  };
}

function requestSetGroup() {
  return {
    type: types.SET_GROUP_REQUEST,
    isFetchingSetGroup: true
  };
}

function requestSetGroupCompleted(setGroup) {
  return {
    type: types.SET_GROUP_COMPLETED,
    isFetchingSetGroup: false,
    setGroup
  };
}

function requestSetGroupError(setGroupError) {
  return {
    type: types.SET_GROUP_ERROR,
    isFetchingSetGroup: false,
    setGroupError
  };
}

export function setGroup(idList, groupId) {
  return async (dispatch, getState) => {
    const planId = getState().studyPlan.planCard.id;
    dispatch(requestSetGroup());
    const response = await Promise.all(
      idList.map(id => api.setGroup(id, groupId))
    )
      .then(response => {
        if (response.every(({ data }) => data.success === true)) {
          dispatch(requestSetGroupCompleted(response));
          dispatch(getPlanWaitingList(planId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestSetGroupError(message));
        } else {
          logError(err);
          dispatch(
            requestSetGroupError(createError("Не удалось добавить в группу"))
          );
        }
      });
    return response;
  };
}

export default {
  getPlanList,
  getPlanCard,
  getPlanSystemInfo,
  getPlanMainInfo,
  getOrganizations,
  getPrograms,
  getPlanGroups,
  getPlanWaitingList,
  removePlanGroup,
  setGroup
};
